import { IFsFileType } from "@r3f-component-data-structure";
import { Texture } from "three";
import { FsBaseFile } from "./base";
export class FsImage extends FsBaseFile {
    type = IFsFileType.Image;
    _filename = 'img';
    _cdnUrl;
    _texture;
    constructor(fileId, projectId, name) {
        super(fileId, projectId, name);
        const url = new URL(this.baseUrl);
        url.pathname = `${url.pathname}/${this._filename}`;
        this._cdnUrl = url.toString();
    }
    async getUrl() {
        return this.fs.getObjectUrl(this._cdnUrl, await this.getBlob());
    }
    async getBlob() {
        return this.fs.getFileBlob(this._cdnUrl);
    }
    async createImageBitmap() {
        return createImageBitmap(await this.getBlob());
    }
    async getAspectRatio() {
        const img = await this.createImageBitmap();
        if (img.height === 0)
            return 1;
        return img.width / img.height;
    }
    async getTexture() {
        if (typeof this._texture === 'undefined') {
            const blob = await this.getBlob();
            this._texture = new Texture();
            this._texture.image = await createImageBitmap(blob, { imageOrientation: 'flipY' });
            this._texture.needsUpdate = true;
        }
        return this._texture;
    }
    getBundlerPath() {
        return `fs/${this.id}/${this._filename}`;
    }
    async getFilesForBundler() {
        const blob = await this.getBlob();
        return [{
                path: this.getBundlerPath(),
                bin: new Uint8Array(await blob.arrayBuffer())
            }];
    }
}
